<style  scoped>
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
</style>
<template>
  <div class="OrderDetails"  style=" padding:20px 5px;
      background: #ffffff;
      box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
      border-radius: 10px;
    ">
    <p class="comeback" @click="comeback()">
      <span class="el-icon-arrow-left"></span>
      <span>{{$t('i18n_Return')}}</span>
    </p>
    <div class="RequestInfo divbox" style="    margin: 3px 29px;">
      <h4>{{$t('i18n_Order_info')}}</h4>
      <ul class="RI_ul">
        <li>
          <p>
            <span style="">{{$t('i18n_Tracking_number')}} </span><span>{{ routes.nos || "-" }}</span>
          </p>
          <p>
            <span>{{$t('i18n_destination')}}</span
            ><span>
              {{ Alldata.waybilldetails.pod_country || "-" }}
            </span>
          </p>
        </li>
        <li>
          <p>
            <span style="">{{$t('i18n_Shipping_method')}} </span
            ><span>{{ Alldata.waybilldetails.transportway || "-" }}</span>
          </p>
          <p>
            <span>{{$t('i18n_Order_date')}}</span
            ><span>
              {{ Alldata.waybilldetails.inputtime || "-" }}
            </span>
          </p>
        </li>
        <li>
          <p>
            <span style="">{{$t('i18n_Original_Port')}} </span
            ><span>
              {{ Alldata.waybilldetails.warehouse || "-" }}
              </span>
          </p>
          <p>
            <span>{{$t('i18n_arrived_warehouse_date')}}</span
            ><span>
              {{ Alldata.waybilldetails.inwarehousetime || "-" }}
            </span>
          </p>
        </li>
      </ul>
    </div>
    <!-- jack start -->
    <div class="jackCard" style="padding: 20px">
      <div style="display: flex; align-items: center">
        <img style="" src="./../../../assets/receiveIcon.png" alt="" />
        <span style="margin-left: 10px; font-size: 20px; font-weight: 550"
          >{{$t('i18n_Package_info')}}</span
        >
      </div>
      <div
       class="reCard"
      >
        <span style="font-size: 18px; line-height: 40px; font-weight: 600">
          {{ Alldata.deswarehouse && Alldata.deswarehouse.warehouse || $t("i18n_no_receiving_information") }}
        </span>
        <span style="line-height: 40px">
           {{ Alldata.deswarehouse &&  Alldata.deswarehouse.tel || "" }}
          {{ Alldata.deswarehouse &&  Alldata.deswarehouse.province || "" }}
          {{ Alldata.deswarehouse &&  Alldata.deswarehouse.city || "" }}
          {{ Alldata.deswarehouse &&  Alldata.deswarehouse.area || "" }}
          {{ Alldata.deswarehouse &&  Alldata.deswarehouse.address || "" }}
        </span>
      </div>
    </div>
    <!-- 请将货物送至以下仓库 -->
    <div v-if="!Alldata.message.isgetgoodstodoor"
      class="jackCard"
      style="
        overflow: hidden;
       
        background: rgb(253 246 217);
      "
    >
      <div style="padding: 10px 30px">
        <span
          style="
            font-size: 26rpx;
            font-family: PingFang SC;
            font-weight: 500;
            color: #c19822;
            line-height: 40rpx;
          "
          >{{$t('i18n_Please_ship_your_package_to_below_warehouse')}}</span
        >
      </div>
      <div style="background: #fff; padding: 15px 30px">
        <span
          style="font-size: 16px;
                  font-family: PingFang SC;
                  font-weight:550
                  line-height: 40px;"
        >
          {{ Alldata.depwarehouse.warehouse || ""  }}

        </span>

         {{ Alldata.depwarehouse.tel || "" }}
        {{ Alldata.depwarehouse.province || "" }}
        {{ Alldata.depwarehouse.city || "" }}
        {{ Alldata.depwarehouse.area || "" }}
        {{ Alldata.depwarehouse.address || "" }}
      </div>
    </div>
<!-- 请将货物送至以下仓库end -->
<!-- 提货信息 -->
     <div v-if="Alldata.message.isgetgoodstodoor"
      class="jackCard"
      style="
        overflow: hidden;
       
        background: rgb(253 246 217);
      "
    >
      <div style="padding: 10px 30px">
        <span
          style="
            font-size: 26rpx;
            font-family: PingFang SC;
            font-weight: 500;
            color: #c19822;
            line-height: 40rpx;
          "
          >提货信息</span
        >
      </div>
      <div style="background: #fff; padding: 15px 30px">
        <span
          style="font-size: 16px;
                                font-family: PingFang SC; 
                                font-weight:550
                                line-height: 40px;"
        >
          {{ Alldata.message.getgoodsname || "" }}
        </span>
        <span style="margin: 0 10px">
          {{ Alldata.message.getgoodstel || "" }}
        </span>
        
        {{ Alldata.message.getgoodsprovince || "" }}
        {{ Alldata.message.getgoodscity || "" }}
        {{ Alldata.message.getgoodsarea || "" }}
        {{ Alldata.message.getgoodsaddress || "" }}
      </div>
    </div>
   <!-- 提货信息end -->
    <!-- jack end  -->
    <div class="jackCard" style="padding: 30px">
      <div>
        <span
          @click="changeAc(1)"
          style="cursor: pointer; margin-right: 5px"
          :class="{ jackTextAc: acIndex == 1, jackText: acIndex == 2 }"
          >{{$t('i18n_Forecast_pakcage_info')}}</span
        >
        <span v-if="state == 2"
          @click="changeAc(2)"
          style="cursor: pointer"
          :class="{ jackTextAc: acIndex == 2, jackText: acIndex == 1 }"
          >{{$t('i18n_Accurated_package_info')}}</span
        >
      </div>
      <div style="margin: 20px 0" v-if="acIndex == 1">
        <el-table
          border
          :data="Alldata.cargobefore"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F3F3F3' }"
        >
          <el-table-column
            type="index"
            :label="$t('i18n_Serial_number')"
            width="75px"
            min-width="8%"
          ></el-table-column>
          <el-table-column prop="boxNo" :label="$t('i18n_FBA_number')">
            <template slot-scope="scope">
                {{scope.row.boxNo || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="citiBoxNo" :label="$t('i18n_Cititrans_Tracking_number')">
            <template slot-scope="scope">
                {{scope.row.citiBoxNo || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="sortNum" :label="$t('i18n_box_counting_number')">
            <template slot-scope="scope">
                {{scope.row.sortNum || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="poTrackingNo" :label="$t('i18n_Amazon_Reference_Number_PO')">
             <template slot-scope="scope">
                {{scope.row.poTrackingNo || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="goodstype" :label="$t('i18n_cargo_classification')">
             <template slot-scope="scope">
                {{scope.row.goodstype || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="weight" :label="$t('i18n_weight_kgs')">
             <template slot-scope="scope">
                {{scope.row.weight || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="cbm" :label="$t('i18n_volume_cbm')">
             <template slot-scope="scope">
                {{scope.row.cbm || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="cbmSize" :label="$t('i18n_size_cm')" min-width="100px">
             <template slot-scope="scope">
                {{scope.row.cbmSize || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="pcs" label="PCS数">
             <template slot-scope="scope">
                {{scope.row.pcs || "-"}}
            </template>
          </el-table-column>
            <el-table-column prop="skuNo" :label="$t('i18n_sku_number')">
             <template slot-scope="scope">
                {{scope.row.skuNum || "-"}}
            </template>
          </el-table-column>
          <el-table-column min-width="100px" prop="piece" :label="$t('i18n_Operation')">
            <template  slot-scope="scope">
              <span
                @click="getBoxDetail(scope.row.goodsList)"
                 class="detailSpan"
                >{{$t('i18n_view_details')}}</span>
              <!-- <span
                @click="toBoxTracking(scope.row.id)"
                 class="detailSpan"
                >查看轨迹</span
              > -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin: 20px 0" v-else>
        <div class="tablebox">
           <el-table
          border
          :data="Alldata.cargo"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F3F3F3' }"
        >
          <el-table-column
            type="index"
            :label="$t('i18n_Serial_number')"
            width="75px"
            min-width="8%"
          ></el-table-column>
          <el-table-column prop="boxNo" :label="$t('i18n_FBA_number')">
            <template slot-scope="scope">
                {{scope.row.boxNo || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="citiBoxNo" :label="$t('i18n_Cititrans_Tracking_number')">
            <template slot-scope="scope">
                {{scope.row.citiBoxNo || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="sortNum" :label="$t('i18n_box_counting_number')">
            <template slot-scope="scope">
                {{scope.row.sortNum || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="poTrackingNo" :label="$t('i18n_Amazon_Reference_Number_PO')">
             <template slot-scope="scope">
                {{scope.row.poTrackingNo || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="goodstype" :label="$t('i18n_cargo_classification')">
             <template slot-scope="scope">
                {{scope.row.goodstype || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="weight" :label="$t('i18n_weight_kgs')">
             <template slot-scope="scope">
                {{scope.row.weight || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="cbm" :label="$t('i18n_volume_cbm')">
             <template slot-scope="scope">
                {{scope.row.cbm || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="cbmSize" :label="$t('i18n_size_cm')" min-width="100px">
             <template slot-scope="scope">
                {{scope.row.cbmSize || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="pcs" :label="$t('i18n_sku_number')">
             <template slot-scope="scope">
                {{scope.row.pcs || "-"}}
            </template>
          </el-table-column>
          <el-table-column width="140px" prop="piece" :label="$t('i18n_Operation')">
            <div  slot-scope="scope" style="width: 100%;text-align: left;">
              <span
                @click="getBoxDetail(scope.row.goodsList)"
                class="detailSpan"
                >{{$t('i18n_view_details')}}</span
              >
              <el-popover v-if="scope.row.pictureUrl"
                          placement="top-start"
                          title=""
                          popper-class="look-image"
                          trigger="hover">
                <span class="detailSpan" slot="reference">{{$t('i18n_view_pictures')}}</span>
                <template>
                  <el-image class="table-goods-cover"
                            v-if="scope.row.pictureUrl"
                            :src="scope.row.pictureUrl"
                            :preview-src-list="[scope.row.pictureUrl]">
                  </el-image>
                  <br>
                  <el-link type="primary" :underline="false" @click="downFile(scope.row.pictureUrl||'')">下载图片</el-link>
                </template>

              </el-popover>
              <!-- 查看轨迹，之前不知道为什么被注释掉了 2021/09/13放开 -->
              <span
                @click="toBoxTracking(scope.row.boxNo)"
                class="detailSpan"
                >{{$t('i18n_view_tracking')}}</span
              >
            </div>
          </el-table-column>
        </el-table>
        </div>
      </div>
    </div>
    <div class="Information divbox" style="    margin: 3px 29px;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('i18n_shipping_fee_info')" name="second">
          <el-table
            border
            :data="tableData1"
            tooltip-effect="dark"
            :header-cell-style="{ background: '#F3F3F3' }"
            ref="multipleTable"
            style="width: 77%; margin-left: 25px; border-bottom: none"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="index"
              :label="$t('i18n_Serial_number')"
              width="75px"
              min-width="8%"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.feeitem !== $t('i18n_Total_payment') &&
                    scope.row.feeitem !== $t('i18n_Covert_to_CNY')
                  "
                  >{{ parseInt(scope.$index + 1) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="feeitem"
              :label="$t('i18n_cost_category')"
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amountBefore"
              :label="$t('i18n_estimated_cost')"
              min-width="8%"
            >
            <template slot-scope="scope">
                {{tableData1[scope.$index].amountBefore || '-'}}
                {{`(${tableData1[scope.$index].amountBeforeCalDesc || '-'})` || '-'}}
              </template>
            </el-table-column>
            <el-table-column
              prop="amount"
              :label="$t('i18n_actual_cost')"
              min-width="8%"
            >
             <template slot-scope="scope">
                {{tableData1[scope.$index].amount}}
                {{`(${tableData1[scope.$index].amountCalDesc || '-'})` || '-'}} 
              </template>
            </el-table-column>
          </el-table>
          <el-table
            border
            :data="twotableData"
            style="
              width: 77%;
              margin-left: 25px;
              border-top: none;
              margin-top: 0px;
            "
            :cell-style="{ padding: '5px 0px' }"
            :show-header="false"
          >
            <el-table-column type="index" label="" width="75px" min-width="8%">
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.feeitem !== $t('i18n_Total_payment') &&
                    scope.row.feeitem !== $t('i18n_Covert_to_CNY')
                  "
                  >{{ parseInt(scope.$index + 1) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="feeitem"
              label=""
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amountBefore"
              label=""
              min-width="8%"
            >
            </el-table-column>
            <el-table-column
              prop="amount"
              label=""
              min-width="8%"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('i18n_tracking_info')" name="third">
          <p
            v-if="!activities.length"
            style="text-align: center; padding-top: 50px; font-size: 16px"
          >
            {{$t('i18n_no_tracking_status_yet')}}
          </p>
          <!-- <el-timeline class="jackContent" v-else>
            <el-timeline-item
              type="primary"
              v-for="(activity, index) in activities"
              :key="index"
              :icon="activity.icon"
              :color="index == 0 ? '' : '#999999'"
              :timestamp="`${activity.occurrenceDate} ${activity.occurrenceTime}`"
            >
              {{ activity.name }}
              <span style="color: #999999; margin-top: 6px">{{
                activity.desc ? activity.desc : "暂无"
              }}</span>
              <span
                style="color: #09bb07; cursor: pointer"
                v-if="activity.detailLinkType == 2"
                @click="getPics(activity.apptWarehouseOrderId)"
                >查看回执</span
              >
            </el-timeline-item>
          </el-timeline> -->
          <div v-if="activities.length!=0">
          <!-- 二维数组轨迹 -->
          <el-collapse v-if="activities[0].fbxBoxTrailDTOList">
            <el-collapse-item v-for="(item, index) in activities" :key="index">
              <template slot="title" >
                <div class="LR_center" style="width:100%;float:left">
                  <div >
                    <span style="padding-left:15px">{{item.commonNos}}</span>
                    <span style="padding-left:15px;font-weight: bold;">{{item.name}}</span>
                    <span style="padding-left:15px;font-weight: bold;">{{item.namee}}</span>
                    <span style="padding-left:15px;color: #999;">{{item.occurrenceDate}}</span>
                    <span style="padding-left:5px;color: #999;">{{item.occurrenceTime}}</span>
                  </div>
                  <div style=";float:right;color:#67C23A">{{$t('i18n_more_tracking_status')}}</div>
                </div>
              </template>
              <el-timeline style="padding:0 30px">
                <el-timeline-item
                  type="primary"
                  v-for="(activity, _index) in item.fbxBoxTrailDTOList"
                  :color="activity.color"
                  :key="_index"
                >
                  <div style="width: 100%; float: left; margin-bottom: 5px">
                    {{ activity.occurrenceDate }}<span style="margin-left:5px">{{ activity.occurrenceTime }}</span>
                  </div>
                  <div style="color: #999; font-size: 11px; display: block">
                    <span>{{activity.name}}</span>
                    <span style="margin-left:10px" v-if="activity.desc">({{ activity.desc }})</span>
                    <span>{{activity.namee}}</span>
                    <el-button type="text" v-if="activity.apptWarehouseOrderId" @click="GetshowText(activity)">查询回执</el-button>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </el-collapse-item>
          </el-collapse>
          <!-- 二维数组轨迹 end-->
          <!-- 相同轨迹 -->
          <div style="width:100%;float:left" v-if="!activities[0].fbxBoxTrailDTOList">
            <el-card class="box-card">
              <div style="width:100%;float:left;margin-bottom:15px" v-for="(item, index) in activities" :key="index" class="text item">
                    <div style="float:left">
                         <span style="padding-left:15px;color: #999;">{{item.occurrenceDate}}
                           <span style="margin-left:10px">{{item.occurrenceTime}}</span>
                         </span>
                    </div>
                    <div style="float:left">
                      <span style="padding-left:15px;font-weight: bold;">{{item.name}}</span>
                      <span style="margin-left:10px" v-if="item.desc">({{ item.desc }})</span>
                      <span style="margin-left:20px">{{item.namee}}</span>
                      <span style="color:#5AB53C;cursor:pointer" v-if="item.apptWarehouseOrderId" @click="GetshowText(item)"> 查询回执</span>
                    </div>
              </div>
            </el-card>
          </div>
          <!-- 相同轨迹 end-->
        </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('i18n_download_labels')" name="download">
           <el-button @click="downLoadLabel()" type="success" size="mini" style="margin:10px">{{$t('i18n_click_and_download_labels')}}</el-button>
        </el-tab-pane>
      </el-tabs>
    </div>


    <el-dialog
      center
      class="jackRadius"
      :before-close="beforeClose"
      :visible.sync="showDialog"
      :title="showPic ? '相关回执' : '箱子轨迹'"
      width="60%"
    >
      <div v-if="this.showDialog && this.showPic">
        <el-image
          v-for="(item, index) in urls"
          :key="index"
          style="
            width: 45%;
            height: 45%;
            border-radius: 20px;
            margin: 10px;
            box-shadow: 0px 0px 55px 2px rgba(6, 2, 3, 0.1);
          "
          :src="item"
          :preview-src-list="urls"
        >
        </el-image>
      </div>
      <div v-if="this.showDialog && this.showBox">
        <el-timeline class="jackContent">
          <el-timeline-item
            type="primary"
            v-for="(activity, index) in boxDatailList"
            :key="index"
            :icon="activity.icon"
            :color="index == 0 ? '' : '#999999'"
            :timestamp="`${activity.occurrenceDate} ${activity.occurrenceTime}`"
          >
            {{ activity.name }}
            <span style="color: #999999; margin-top: 6px">{{
              activity.desc ? activity.desc : "暂无"
            }}</span>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>


    <!-- 查看箱子详情弹窗 -->
     <el-dialog
      center
      class="jackRadius"
      :visible.sync="showGoodsList"
      :title="$t('i18n_Box_Details')"
      width="80%"
    >
      <div>
        <el-table
          border  size="mini"
          :data="goodsList"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#5ab53c21' }"
          ref=""
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column
            type="index"
            label="序号"
            width="75px"
            min-width="8%" -->
          ></el-table-column>
          <el-table-column prop="boxNo" :label="$t('i18n_Product_name_in_Chinese')">
            <template slot-scope="scope">
                {{scope.row.namec || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="poTrackingNo" :label="$t('i18n_product_name_in_English')">
             <template slot-scope="scope">
                {{scope.row.namee || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="goodstype" :label="$t('i18n_brands')">
             <template slot-scope="scope">
                {{scope.row.brand || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="weight" label="SKU">
             <template slot-scope="scope">
                {{scope.row.sku || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="number" :label="$t('i18n_product_quantity')">
             <template slot-scope="scope">
                {{scope.row.number || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="cbm" :label="$t('i18n_HTS_code')">
             <template slot-scope="scope">
                {{scope.row.hsCode || "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="pcs" :label="$t('i18n_product_value')">
             <template slot-scope="scope">
                {{scope.row.price > 0 ? scope.row.price : '-'}}
            </template>
          </el-table-column>
           <el-table-column prop="pcs" :label="$t('i18n_Material_in_Chinese')">
             <template slot-scope="scope">
                {{scope.row.materialc || "-"}}
            </template>
          </el-table-column>
           <el-table-column prop="pcs" :label="$t('i18n_material_in_English')">
             <template slot-scope="scope">
                {{scope.row.materiale || "-"}}
            </template>
          </el-table-column>
           <el-table-column prop="pcs" :label="$t('i18n_Product_uses_in_Chinese')">
             <template slot-scope="scope">
                {{scope.row.purposec || "-"}}
            </template>
          </el-table-column>
           <el-table-column prop="pcs" :label="$t('i18n_Product_uses_in_English')">
             <template slot-scope="scope">
                {{scope.row.purposee || "-"}}
            </template>
          </el-table-column>
           <el-table-column prop="pcs" :label="$t('i18n_Product_Images')">
             <template slot-scope="scope">
                {{scope.row.pcs || "-"}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import qs from "qs";
import fileDownload from 'js-file-download'
export default {
  name: "FbaOrderDetails",
  data() {
    return {
      state: 0,
      showGoodsList: false,
      goodsList: [],
      boxDatailList: [],
      acIndex: 1,
      boxInfo: [],
      urls: [],
      showDialog: false,
      showPic: false,
      showBox: false,
      orderNo: "FAAE202012190129A",
      activities: [],
      // jack
      tableData_C1: [
        {
          goodname: "衣服",
          weight: "50",
          cbm: "3",
          piece: "200",
        },
      ],
      tableData_C2: [
        {
          goodname: "衣服",
          weight: "50",
          cbm: "3",
          piece: "200",
        },
      ],
      tableData1: [
        {
          feeitem: "海运费",
          amountBefore: "CNY 50",
          amount: "CNY 30",
        },
      ],
      twotableData: [
        {
          feeitem: "合计",
          amountBefore: "CNY 50",
          amount: "CNY 30",
        },
        {
          feeitem: "合计",
          amountBefore: "CNY 50",
          amount: "CNY 30",
        },
      ],
      Alldata: {
        cargobefore: [{}],
        combincostinfo: {
          amount: "",
          amountBefore: "",
          combinCostinfoList: [
            {
              amount: "",
              amountBefore: "",
              feecode: "",
              feeitem: "",
            },
          ],
          totalCost: "",
          totalCostBefore: "",
        },
        costbeforeinfo: {
          amount1: "",
          feeitemBeforeList: [
            {
              amountBefore: "",
              cnyamountBefore: "",
              cnycurrencyBefore: "",
              currencyBefore: "",
              feecode: "",
              feeitemBefore: "",
              piece: "",
              price: "",
            },
          ],
        },
        costinfo: {
          amount2: "",
          feeitemList: [
            {
              amount: "",
              cnyamount: "",
              cnycurrency: "",
              currency: "",
              feecode: "",
              feeitem: "",
              piece: "",
              price: "",
            },
          ],
        },
        depwarehouse: {
          address: "",
          area: "",
          city: "",
          province: "",
          tel: "",
          warehouse: "",
        },
        deswarehouse: {
          address: "",
          area: "",
          city: "",
          province: "",
          tel: "",
          warehouse: "",
        },
        message: {
          cneename: "",
          getgoodsaddress: "",
          getgoodsarea: "",
          getgoodscity: "",
          getgoodsname: "",
          getgoodsprovince: "",
          getgoodstel: "",
          goodstype: "",
          id: "",
          inputtime: "",
          inwarehoustime: "",
          ischangeaddress: true,
          isgetgoodstodoor: true,
          issendgoodstodoor: true,
          pod_country: "",
          pod_country_area: "",
          rece_address: "",
          rece_city: "",
          rece_country: "",
          rece_tel: "",
          shipper_name: "",
          shipper_tel: "",
        },
        schedule: {
          ata: "",
          atd: "",
          cls: "",
          eta: "",
          etd: "",
          pod: "",
          pol: "",
          route: "",
          shippingcompany: "",
          vessel: "",
          voyage: "",
        },
        settleinfo: {
          fkcode: "",
          fkstate: "",
          nopaid: "",
          paid: "",
          paymethod: "",
        },
        state: {
          dealdata: "",
          location: "",
        },
        waybilldetails: {
          abbr: "",
          createway: "",
          cusNos: "",
          inputtime: "",
          inwarehousetime: "",
          jobid: "",
          namec: "",
          nos: "",
          pod_country: "",
          product: "",
          remark: "",
          transportway: "",
          warehouse: "",
        },
      },
      routes: {},
      activeName: "second",
      reverse: false,

      guiji: false,
    };
  },
  watch: {},
  methods: {
    // 下载标签
    downLoadLabel() {
      this.axios
        .get(`/busFbx/downFBXOrderLabel/${this.routes.nos}`)
        .then((res) => {
          if (res.data.code == 200) {
            console.log();
            let a = document.createElement("a");
            a.setAttribute("href", res.data.data);
            a.setAttribute("target", "_blank");
            a.click();
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
      // this.axios({
      //   method: 'get',
      //   url: `/busFbx/downFBXOrderLabelNew/${this.routes.nos}`,
      //   responseType: 'blob'
      // }).then((res) => {
      //   if (res) {
      //     fileDownload(res.data, `订单标签${this.routes.nos}.pdf`)
      //     this.$message.success('下载成功!')
      //   }
      // })
      // .catch((err) => {
      //   console.log(err)
      // })
    },
    changeAc(index) {
      this.acIndex = index;
    },
    beforeClose() {
      this.showPic = false;
      this.showBox = false;
      this.showDialog = false;
    },
    getBoxDetail(goodsList) {
      this.goodsList = goodsList;
      this.showGoodsList = true;
      // console.log(goodsList);
    },
    toBoxTracking(nos) {
      // console.log(id);
      this.axios
        // .post(
        //   `fbxTrail/findBoxTrail`,
        //   qs.stringify({
        //     orderNo: this.routes.nos,
        //     boxId: id,
        //   })
        // )
        .post(`/track/newQueryCommonTrackByNo/${nos}`)
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.datas && res.data.datas.length) {
              console.log(2);
              this.boxDatailList = res.data.datas;
              this.showDialog = true;
              this.showBox = true;
            } else {
              this.$message(this.$t("i18n_No_data"));
            }
          } else {
            this.$message(this.$t('i18n_Failed_to_get'));
          }
        })
        .catch((res) => {});
    },
    getBoxInfo() {
      this.axios
        .post(
          `/fbxTrail/queryApptWarehouseOrderBoxs`,
          qs.stringify({
            orderNo: this.orderNo,
            apptWarehouseOrderId: "18955654000",
          })
        )
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.datas.length) {
              this.boxInfo = res.data.datas;
              //   this.showDialog = true
              //   this.showBox = true;
            } else {
              this.$message(this.$t("i18n_No_data"));
            }
          } else {
            this.$message(this.$t('i18n_Failed_to_get'));
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getPics(id) {
      this.axios
        .post(`/fbxTrail/findApptWarehouseOrderReceipt/${id}`, {})
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.datas.length) {
              this.urls = res.data.datas;
              this.showDialog = true;
              this.showPic = true;
            } else {
              this.$message(this.$t("i18n_No_data"));
            }
          } else {
            this.$message(this.$t('i18n_Failed_to_get'));
          }
          this.loading = false;
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    handleClick(tab, event) {
      //tabs的点击方法
      // console.log(tab.paneName);
      if (tab.paneName === "third") {
        this.axios
          .post(`/track/newQueryCommonTrackByNo/${this.routes.nos}`)
          .then((response) => {
            console.log(response.data.data)
            if (response.data.code == 200) {
              if (response.data.data.length) {
                response.data.data.forEach((item) => {
                  if(item.fbxBoxTrailDTOList){
                    item.fbxBoxTrailDTOList.forEach(_item=>{
                      this.$set(_item, "color", "#909399");
                    })
                    item.fbxBoxTrailDTOList[0].color = "#409EFF";
                  }
                });
                this.activities = response.data.data;
              } else {
                this.$message(this.$t("i18n_No_data"));
              }
            } else {
              this.$message(this.$t('i18n_Failed_to_get'));
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    preViewPic(url) {
      uni.previewImage({
        urls: [url],
      });
    },
    // jack
    getSummaries(param) {
      //合计第一列不显示合计
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      return sums;
    },
    comeback() {
      //返回上一页
      this.$router.push({ name: "FBAheader" });
    },
    handleSelectionChange(val) {
      //table方法
      this.multipleSelection = val;
    },

    getalldata() {
      let data = {
        jobtype: "FBX",
        language: "CN",
        nos: this.routes.nos,
        state: this.routes.state,
      };
      // console.log(data)

      this.axios
        .post("/busFbx/getFbxJobsHistoryWebSingleList", data)
        .then((response) => {
          console.log(response.data.data);
          this.Alldata = response.data.data;
          console.log(this.Alldata);
          // this.Alldata = JSON.parse(JSON.stringify(this.Alldata))
          this.tableData_C1 = response.data.data.cargobefore;
          this.tableData_C2 = response.data.data.cargo;
          this.tableData1 =
            response.data.data.combincostinfo.combinCostinfoList; //数据列表
          this.twotableData = [
            {
              feeitem: this.$t("i18n_Total_payment"),
              amountBefore: response.data.data.combincostinfo.totalCostBefore,
              amount: response.data.data.combincostinfo.totalCost,
            },
            {
              feeitem: this.$t("i18n_Covert_to_CNY"),
              amountBefore: response.data.data.combincostinfo.amountBefore,
              amount: response.data.data.combincostinfo.amount,
            },
          ];
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    CargoTrackByNo() {},
    /**
     * 下载
     */
    downFile(url = ""){
      // let baseUrl = this.axios.defaults.baseURL.replace(/\/$/ig,'');
      try {
        window.open(url);
      }catch (e) {
        window.location.href = url;
      }
    },
  },
  created() {
    this.routes = this.$route.query;
    this.state = this.routes.state;
    this.CargoTrackByNo();
    this.getalldata();
  },
  mounted() {},
};
</script>

<style lang="scss" >

.detailSpan {
color: $d2d-color-primary; cursor: pointer
}
.reCard {
  margin: 20px 30px 5px;
  padding: 0 10px;
  height: 40px;
  border: 1px solid $d2d-color-primary;
  background: $d2d-color-primary-light;
}
.jackTextAc {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.jackText {
  font-size: 18px;
  font-weight: bold;
  color: #999;
}
.jackContent {
  padding: 10px;
  .el-timeline-item__content {
    width: 500px;
  }
}
.jackRadius {
  /deep/.el-dialog {
    border-radius: 20px;
  }
}
.jackCard {
  
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  margin: 20px 60px 20px 30px;
  background: #ffffff;
}
.OrderDetails {
  // width: 100%;
  /* background: #FBFBFB; */
  border-radius: 5px;
}
.OrderDetails .comeback {
  width: 120px;
  margin-bottom: 5px;
  font-size: 18px;
  cursor: pointer;
}
.OrderDetails .comeback:hover {
  color: #409eff;
}
.OrderDetails .comeback span:nth-child(1) {
  margin-left: 12px;
  margin-right: 5px;
  font-size: 22px;
  vertical-align: -1px;
}
.OrderDetails .divbox {
  width: 95%;
  margin: 0 auto;
  margin-bottom: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
}
.OrderDetails h4 {
  height: 18px;
  padding-top: 18px;
  margin-left: 24px;
  font-size: 18px;
  font-family: "PingFang SC";
  font-weight: bold;
  color: #343434;
}
.OrderDetails .RequestInfo {
  /* height: 215px; */
  margin-top: 22px;
  /* padding-bottom: 20px; */
}
.OrderDetails .Blurb {
  width: 95%;
  /* height: 242px; */
  margin: 0 auto;
  margin-bottom: 20px;
  display: flex;
}
.OrderDetails .Information {
  /* height: 283px; */
  padding-bottom: 22px;
}
.OrderDetails .Blurb .tablebox {
  width: 49%;
  background: #ffffff;
  padding-bottom: 20px !important;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
}
.OrderDetails .Blurb .tablebox:nth-child(1) {
  margin-right: 2%;
}
.OrderDetails .divbox .RI_ul {
  display: flex;
}
.OrderDetails .divbox .RI_ul li {
  width: 31%;
  margin-left: 24px;
  margin-top: 20px;
}
.OrderDetails .divbox .RI_ul li:nth-child(1) {
  margin-left: 0;
}
.OrderDetails .divbox .RI_ul li:nth-child(2) {
  margin-left: 1%;
  margin-right: 1%;
}
.OrderDetails .divbox .RI_ul li p {
  margin-bottom: 19px;
  font-size: 14px;
  /* mar- */
}
.OrderDetails .divbox .RI_ul li p span {
  display: inline-block;
  // overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}
.OrderDetails .divbox .RI_ul li p span:nth-child(1) {
  width: 130px;
  margin-right: 27px;
  color: #9a9a9a;
  text-align: right;
}
.OrderDetails .divbox .RI_ul li p span:nth-child(2) {
  width: 200px;
  height: 16px;
  color: #343434 !important;
  text-align: left;
}
.OrderDetails .Information .RI_ul li {
  margin-top: 0px;
}
/* element */
.OrderDetails .endtwotr {
  margin-top: -2px;
}
.OrderDetails .Information .el-timeline-item {
  padding-bottom: 30px;
}
.OrderDetails .Blurb .el-table td,
.el-table th {
  padding: 8px 0;
}
.OrderDetails .Information .el-table td,
.el-table th {
  padding: 7px 0;
}
.OrderDetails .el-tabs__item {
  font-size: 16px;
}
.OrderDetails .el-timeline-item__tail {
  position: absolute;
  left: 155px;
  top: 7px;
}
.OrderDetails .el-timeline-item__node--normal {
  left: 150px;
}
.OrderDetails .el-timeline-item__wrapper {
  width: 260px;
  padding-left: 175px;
  font-size: 14px;
  font-family: "PingFang SC";
  font-weight: 500;
  color: #333333;
}
.OrderDetails .el-timeline-item__timestamp.is-bottom {
  position: absolute;
  right: 295px;
  top: 3px;
  margin-top: 0;
  color: #999999;
  font-size: 11px;
}
.OrderDetails .el-tabs__nav-wrap::after {
  background: none;
}
.OrderDetails .el-table td,
.el-table th {
  text-align: center;
}
.OrderDetails .Blurb .el-table__header tr,
.OrderDetails .Blurb .el-table__header th {
  padding: 0;
  height: 38px;
  line-height: 38px;
}
.OrderDetails .Information .el-table__header tr,
.OrderDetails .Information .el-table__header th {
  padding: 0;
  height: 31px;
  line-height: 31px;
}
.OrderDetails .el-tabs__header {
  margin-left: 21px;
  padding-top: 5px;
  margin-bottom: 25px;
  font-size: 18px;
}
/* table 滚动条 */
.OrderDetails .el-table__body-wrapper::-webkit-scrollbar {
  width: 3px;
}
.OrderDetails .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.OrderDetails .el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}
.look-image{
  min-width: 60px;
  text-align: center;
}
.el-table .cell {
  word-break: keep-all;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/FBAheader/FbaOrderDetails.vue